import React from 'react';

import GroupsAccordions from 'web/pages/private/CommonPages/MyNetworks/YourGroups/GroupsAccordions'
import { BoxContainer, BoxContainerHeader } from "web/pages/private/CommonPages/MyNetworks/myNetworksStyled";

const YourGroups = ({ groupListResponse, pageLanguageContents, closeIconCallBack, inviteCallBack }) => {
    return (
        <BoxContainer>
            <BoxContainerHeader>
                <h2>
                    {pageLanguageContents?.MyCommunity[8]?.YourGroups}
                </h2>
            </BoxContainerHeader>
            <GroupsAccordions groupListResponse={groupListResponse} pageLanguageContents={pageLanguageContents} closeIconCallBack={closeIconCallBack} inviteCallBack={inviteCallBack} />
        </BoxContainer>
    );
}



export default YourGroups;
